import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { MdOutlineLock } from "react-icons/md";
import { TbBellRinging } from 'react-icons/tb';
import { ClipLoader } from 'react-spinners';
import * as APIHelper from '../Helper/apiFetch';


const Notify = ({ title }) => {
    const [notify, setNotify] = useState(false);
    const [loader, setLoader] = useState(false);

    const enableNotification = () => {
        setLoader(true);
        /* APIHelper.setNotification().then(resp => {
            setLoader(false);
            if (resp.error) {
                navigate('/error');
            } else {
                setNotify(Boolean(resp.success));
            }
        }) */
    }

    const navigate = useNavigate();

    useEffect(() => {
        APIHelper.getNotification().then(resp => {
            if (resp.error) {
                navigate('/error');
            } else {
                setNotify(Boolean(resp.status));
            }
        })
    }, []);

    return (
        <div className='topStackerLockScreen'>
            <div className='topStackerLockScreen-title'>
                <MdOutlineLock color='#C14673' size={48} />
                <div className='refferLocktitle'>{title}</div>
                <div>Predict and Win Bitcoin Rewards!</div>
                <div className='refferSubLocktitle'>Coming Soon</div>
                {
                    notify ? <div className="refferSubLocktitle" style={{ color: '#FFFFFF', width: '280px' }}>Great! You will be notified once the contest is live.</div> :

                        <div className="button-Container">
                            <button className='notifyButton' onClick={enableNotification}>
                                {
                                    loader ? <div style={{ padding: '4px 30px 0px 30px' }}><ClipLoader
                                        color={"#FFFFFF"}
                                        size={18}
                                        loading={true}
                                    /></div>
                                        :
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <TbBellRinging style={{ marginRight: '5px', fontSize: '24px' }} /><div>NOTIFY ME</div>
                                        </div>
                                }
                            </button>
                        </div>
                }

            </div>
        </div>

    )
}

export default Notify;
